<template>
	<CreationWizardStepHeaderWrapper v-bind="headerWrapperProps" v-on="headerWrapperListeners">
		<div class="display-flex">
			<PortalHeader />
		</div>
	</CreationWizardStepHeaderWrapper>
</template>

<script>
import PortalHeader from '../common/PortalHeader.vue';
import WizardStepMixin from '../WizardStepMixin';
import props from './CreatePortal.props';
export default {
	name: 'CreatePortalHeader',
	mixins: [WizardStepMixin],
	props,
	components: { PortalHeader },
};
</script>

<style scoped lang="scss"></style>
